<div *ngIf="isLoading" class="loading-spinner">
  <div class="spinner-border text-primary" role="status">
    <span class="visually-hidden">Loading...</span>
  </div>
</div>

<div *ngIf="!isLoading && pageContent" class="page-content-container">
    <h1 class="page-title">{{ pageContent.title }}</h1>
    
    <div *ngFor="let section of pageContent.sections" class="content-section" [id]="section.id">
      <h2 class="section-title" *ngIf="section.title && section.title.length > 0">{{ section.title }}</h2>
      <div class="section-content" [innerHTML]="section.content"></div>
      
      <!-- Subsections if any -->
      <div *ngIf="section.subsections && section.subsections.length > 0">
        <div *ngFor="let subsection of section.subsections" class="content-subsection" [id]="subsection.id">
          <h3 class="subsection-title">{{ subsection.title }}</h3>
          <div class="subsection-content" [innerHTML]="subsection.content"></div>
        </div>
      </div>
    </div>
    
    <!-- Add previous/next navigation at the bottom -->
    <app-prev-next-navigation></app-prev-next-navigation>
  </div>